export default __webpack_public_path__ + "static/media/logo-shadow.fac82ecd.svg";